export default "__VITE_ASSET__Kt39xBXS__"